import React from 'react'
import RadioGroup from 'devextreme-react/radio-group';
import { Popup, Position, ToolbarItem } from 'devextreme-react/popup';

export default ({ onLayoutSelect }) => {


    const layouts1 = [
        { id: 1, label: "Add single column row" },
        { id: 2, label: "Add 2 column row" },
        { id: 3, label: "Add 3 column row" }
    ];

    function selectHandler(e) {

        onLayoutSelect(e.value)
    }

    return (
        <Popup
            width={330}
            height={220}
            visible={true}
            hideOnOutsideClick={false}
            showCloseButton={false}
            title="Select a layout">
        <div >
            
            <div className="dx-field">
                <div className="dx-field-value">
                     <RadioGroup
                        displayExpr="label"
                        valueExpr="id"
                        items={layouts1}
                        onValueChanged={selectHandler}
                    />
            </div>
            </div>
            </div>

            </Popup>
      
        )
}
